import { CATEGORY_WHITELIST } from '@/lib/middleware/variantRedirect.helper'

/** Second segment of `/{category}/…` that is listing UI, not a product slug. */
const RESERVED_SECOND_SEGMENT = new Set([
  'all',
  'newest',
  'best-sellers',
  'in-stock',
  'out-of-stock',
  'page',
])

/**
 * Homepage and “probably a product” URLs (`/{known-category}/…`).
 * Intentionally lightweight — a few edge cases may slip through; that’s fine for a nudge modal.
 */
export function shouldOfferWrongStorefrontRegionModal(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '') || '/'
  if (p === '/') return true
  if (p.startsWith('/product/')) return true

  const parts = p.split('/').filter(Boolean)
  if (parts.length < 2) return false
  if (!(CATEGORY_WHITELIST as Set<string>).has(parts[0])) return false
  if (RESERVED_SECOND_SEGMENT.has(parts[1].toLowerCase())) return false

  return true
}
